module.exports = {"371122001":"城阳街道","371122102":"招贤镇","371122103":"阎庄镇","371122104":"夏庄镇","371122105":"刘官庄镇","371122106":"峤山镇","371122107":"小店镇","371122109":"龙山镇","371122110":"东莞镇","371122111":"浮来山镇","371122112":"陵阳镇","371122113":"店子集镇","371122114":"长岭镇","371122115":"安庄镇","371122116":"棋山镇","371122117":"洛河镇","371122118":"寨里河镇","371122119":"桑园镇","371122120":"果庄镇","371122206":"库山乡","371122400":"莒县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371122.json
// module id = 1338
// module chunks = 0